const initialState = {
    data: null,
    error: null,
};
const forgetPasswordRedux = (state = initialState, action) => {
    switch (action.type) {
        case 'FORGETPASSWORD_SUCCESS':
            return {
                ...state,
                data: action.payload,
                error: null,
            };
        case 'FORGETPASSWORD_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        case 'FORGETPASSWORD_RESET':
            return initialState;
        default:
            return state;
    }
}

export default forgetPasswordRedux;